export interface Novel {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  excerpt: string;
  rating: number;
  tags: string[];
  publishDate: string;
  content: string;
  wordCount: string;
  status: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '甜宠小说', slug: 'tianchong', icon: 'ri-heart-line', description: '甜蜜宠爱，让人心动的恋爱故事，每一页都洋溢着幸福的味道。' },
  { name: '萌系小说', slug: 'mengxi', icon: 'ri-emotion-happy-line', description: '可爱角色与温暖日常，治愈你的每一个疲惫时刻。' },
  { name: '治愈系小说', slug: 'zhiyu', icon: 'ri-mental-health-line', description: '温柔的文字抚慰心灵，带给你最柔软的阅读体验。' },
  { name: '校园小说', slug: 'xiaoyuan', icon: 'ri-book-open-line', description: '青春校园里的纯真故事，回到最美好的学生时代。' },
  { name: '奇幻小说', slug: 'qihuan', icon: 'ri-magic-line', description: '奇幻世界中的可爱冒险，脑洞大开又温暖人心。' },
];

export const novels: Novel[] = [
  {
    id: '1',
    title: '猫系少女的甜蜜日常',
    author: '樱花小兔',
    category: '萌系小说',
    categorySlug: 'mengxi',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20illustration%20of%20a%20girl%20with%20cat%20ears%20in%20pastel%20pink%20and%20cream%20colors%2C%20soft%20watercolor%20style%2C%20light%20background%20with%20cherry%20blossoms%2C%20kawaii%20anime%20art%20style%2C%20warm%20and%20cozy%20atmosphere&width=400&height=560&seq=novel-cover-1&orientation=portrait',
    description: '林小喵是一个有着猫系性格的可爱少女，她安静、独立，却又在不经意间流露出让人无法抗拒的软萌魅力。从校园到职场，她遇见了温暖如阳光的邻家哥哥，展开了一段又甜又萌的恋爱日常。',
    excerpt: '林小喵蹲在沙发角落，抱着比她整个人还大的抱枕，只露出一双圆溜溜的大眼睛。窗外阳光正好，她的猫耳朵发卡在光线下微微反光——那是他最心动的画面。',
    rating: 4.8,
    tags: ['日常', '甜宠', '温馨', '猫系'],
    publishDate: '2024-03-15',
    content: '',
    wordCount: '32万字',
    status: '已完结',
  },
  {
    id: '2',
    title: '总裁的棉花糖恋人',
    author: '甜心草莓酱',
    category: '甜宠小说',
    categorySlug: 'tianchong',
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20pastel%20illustration%20of%20a%20sweet%20couple%20sharing%20cotton%20candy%2C%20romantic%20pink%20and%20peach%20tones%2C%20kawaii%20anime%20art%20style%2C%20dreamy%20bokeh%20background%2C%20warm%20gentle%20lighting&width=400&height=560&seq=novel-cover-2&orientation=portrait',
    description: '苏绵绵是公司里最不起眼的小职员，性格软得像一团棉花糖。冷面总裁顾北辰却偏偏对她上了心，把她宠上了天。全员都在磕这对CP的甜蜜日常，让人甜到牙疼！',
    excerpt: '"绵绵，过来。"总裁办公室的门打开，顾北辰伸出手。苏绵绵红着脸走过去，被一把拉进怀里。全公司的人都在八卦群里炸开了锅：啊啊啊总裁又在发糖了！',
    rating: 4.9,
    tags: ['霸道总裁', '甜宠', '办公室', '宠文'],
    publishDate: '2024-02-20',
    content: '',
    wordCount: '45万字',
    status: '已完结',
  },
  {
    id: '3',
    title: '小狐狸的治愈时光',
    author: '月亮上的猫',
    category: '治愈系小说',
    categorySlug: 'zhiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Adorable%20fox%20girl%20illustration%20in%20a%20cozy%20cottage%20with%20warm%20sunlight%2C%20soft%20watercolor%20aesthetic%2C%20cream%20and%20warm%20orange%20tones%2C%20kawaii%20style%2C%20peaceful%20atmosphere&width=400&height=560&seq=novel-cover-3&orientation=portrait',
    description: '在森林深处的小木屋里，住着一只化为人形的小狐狸。她开了一家小小的杂货铺，用自己采摘的花草制作香薰和茶包。每一位到访的客人都带着心事而来，带着微笑离开。这是一个关于温柔与治愈的童话。',
    excerpt: '小狐狸把刚晒干的薰衣草装进棉布袋里，系上淡紫色的蝴蝶结。阳光透过木窗洒在她的尾巴上，暖暖的。她想，今天会不会有新的客人推开那扇吱呀作响的木门呢？',
    rating: 4.7,
    tags: ['治愈', '幻想', '温馨', '日常'],
    publishDate: '2024-01-10',
    content: '',
    wordCount: '28万字',
    status: '连载中',
  },
  {
    id: '4',
    title: '同桌是只小奶狗',
    author: '草莓味的风',
    category: '校园小说',
    categorySlug: 'xiaoyuan',
    coverImage: 'https://readdy.ai/api/search-image?query=High%20school%20romance%20illustration%20of%20a%20cute%20boy%20and%20girl%20sitting%20at%20a%20desk%20together%2C%20cherry%20blossoms%20outside%20window%2C%20soft%20pastel%20colors%2C%20kawaii%20anime%20art%20style%2C%20warm%20spring%20lighting&width=400&height=560&seq=novel-cover-4&orientation=portrait',
    description: '转学生江辰看起来又奶又乖，笑起来还有两颗小虎牙，被全班女生封为"小奶狗系男友"。可谁能想到，这只小奶狗其实是隐藏的学霸大佬？从同桌到恋人，这段校园初恋甜到飞起。',
    excerpt: '"这道题你不会吗？我教你。"江辰微微侧过头，离她的距离不过十厘米。他的睫毛好长，皮肤好白，笑起来的样子让她的心跳漏了整整一拍。完了，她好像喜欢上自己的同桌了。',
    rating: 4.8,
    tags: ['校园', '初恋', '学霸', '甜宠'],
    publishDate: '2024-04-05',
    content: '',
    wordCount: '36万字',
    status: '已完结',
  },
  {
    id: '5',
    title: '魔法甜点屋',
    author: '糖霜小仙',
    category: '奇幻小说',
    categorySlug: 'qihuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Magical%20bakery%20illustration%20with%20floating%20pastries%20and%20sparkles%2C%20cute%20witch%20girl%20baking%2C%20warm%20golden%20and%20cream%20tones%2C%20kawaii%20fantasy%20art%20style%2C%20cozy%20magical%20atmosphere&width=400&height=560&seq=novel-cover-5&orientation=portrait',
    description: '苏糖糖继承了奶奶留下的一家神奇甜点屋。这里的每一份甜点都有魔法——马卡龙能让人记起美好的回忆，热可可能让伤心的人重拾笑容。在这个温暖的小店里，魔法与甜蜜在每一个角落绽放。',
    excerpt: '烤箱"叮"的一声响起，一阵金色的光芒从里面溢出。苏糖糖戴上手套，小心翼翼地取出一盘会发光的曲奇饼干。这是今天的第一位客人预定的"勇气曲奇"，吃下去就能勇敢面对一切。',
    rating: 4.6,
    tags: ['奇幻', '甜点', '魔法', '日常'],
    publishDate: '2024-02-28',
    content: '',
    wordCount: '30万字',
    status: '连载中',
  },
  {
    id: '6',
    title: '青梅她超可爱',
    author: '柠檬不酸',
    category: '甜宠小说',
    categorySlug: 'tianchong',
    coverImage: 'https://readdy.ai/api/search-image?query=Childhood%20friends%20romance%20illustration%2C%20boy%20and%20girl%20under%20a%20big%20tree%2C%20soft%20green%20and%20peach%20colors%2C%20kawaii%20anime%20style%2C%20warm%20summer%20afternoon%20lighting&width=400&height=560&seq=novel-cover-6&orientation=portrait',
    description: '从小到大，沈知意就认定了一件事——他的小青梅是全天下最可爱的女孩子。从幼儿园到大学，他默默守护了她十八年。当终于鼓起勇气表白时，才发现原来她也一直喜欢着自己。',
    excerpt: '"沈知意，你又偷偷往我书包里塞牛奶！"她气鼓鼓地回头，却看到他笑得一脸温柔。"我家小青梅要长高高，我乐意。"阳光洒在他身上，她觉得自己的脸烫得可以煎鸡蛋了。',
    rating: 4.9,
    tags: ['青梅竹马', '甜宠', '校园', '养成'],
    publishDate: '2024-05-12',
    content: '',
    wordCount: '40万字',
    status: '已完结',
  },
  {
    id: '7',
    title: '兔兔客栈的温馨日常',
    author: '胡萝卜酱',
    category: '萌系小说',
    categorySlug: 'mengxi',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20bunny%20girl%20running%20a%20small%20inn%20illustration%2C%20fluffy%20rabbits%20everywhere%2C%20soft%20cream%20and%20pink%20tones%2C%20kawaii%20anime%20art%20style%2C%20cozy%20cottage%20interior%20with%20flowers&width=400&height=560&seq=novel-cover-7&orientation=portrait',
    description: '在云朵镇的山坡上，有一家兔子主题的温馨客栈。老板娘白团团是一只修炼成精的兔兔，她做的胡萝卜蛋糕是全镇最好吃的。每天都有来自各地的可爱客人入住，发生着各种温暖有趣的小故事。',
    excerpt: '白团团踮起脚尖，把新做的小雏菊花环挂在客栈门牌上。今天要入住的是一位从很远很远的地方来的旅人，听说他走遍了整个世界，却从未找到过真正的温暖。兔兔决定，一定要让他在这里感受到家的味道。',
    rating: 4.7,
    tags: ['萌系', '日常', '幻想', '治愈'],
    publishDate: '2024-03-28',
    content: '',
    wordCount: '25万字',
    status: '连载中',
  },
  {
    id: '8',
    title: '星星落在你眼里',
    author: '银河泡芙',
    category: '校园小说',
    categorySlug: 'xiaoyuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Starry%20night%20romance%20illustration%2C%20boy%20and%20girl%20stargazing%20on%20school%20rooftop%2C%20soft%20navy%20and%20gold%20tones%2C%20kawaii%20anime%20style%2C%20romantic%20atmosphere&width=400&height=560&seq=novel-cover-8&orientation=portrait',
    description: '天文社唯一的社员顾星辰，遇上了因为失眠而半夜溜进学校天台的新同学夏晚晚。从那以后，每个晴朗的夜晚，他们都在天台上一起看星星。他教她认星座，她给他讲故事。星星见证了这段最纯粹的校园初恋。',
    excerpt: '"那颗最亮的星星叫什么？"夏晚晚指着夜空。顾星辰看着她的侧脸，轻声说："叫你的名字。"她没有注意到，他说这句话的时候，眼睛里倒映的不是星光，而是她的身影。',
    rating: 4.8,
    tags: ['校园', '纯爱', '治愈', '青春'],
    publishDate: '2024-04-20',
    content: '',
    wordCount: '33万字',
    status: '已完结',
  },
  {
    id: '9',
    title: '云朵面包房',
    author: '软软云朵',
    category: '治愈系小说',
    categorySlug: 'zhiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Cloud%20shaped%20bakery%20illustration%20with%20fluffy%20bread%2C%20cute%20baker%20girl%2C%20soft%20cream%20and%20sky%20blue%20tones%2C%20kawaii%20anime%20art%20style%2C%20dreamy%20floating%20island%20aesthetic&width=400&height=560&seq=novel-cover-9&orientation=portrait',
    description: '在天空之城的角落，有一家漂浮在云朵上的面包房。店主小云做的面包有着神奇的力量——咬一口云朵吐司，烦恼就会随着面包的香气飘散。每一个来到这里的客人，都会带着满满的能量重新出发。',
    excerpt: '清晨的第一缕阳光穿过云层，小云把刚出炉的云朵面包摆上货架。松软的面包像一朵朵迷你白云，散发着甜甜的奶香。她推开窗户，对着下面的城市挥了挥手："今天也要加油哦，大家！"',
    rating: 4.6,
    tags: ['治愈', '幻想', '美食', '正能量'],
    publishDate: '2024-01-25',
    content: '',
    wordCount: '22万字',
    status: '已完结',
  },
  {
    id: '10',
    title: '龙族公主的甜味冒险',
    author: '蜜桃乌龙茶',
    category: '奇幻小说',
    categorySlug: 'qihuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20dragon%20princess%20illustration%20with%20tiny%20wings%20and%20tail%2C%20holding%20a%20lollipop%2C%20soft%20pastel%20pink%20and%20gold%20tones%2C%20kawaii%20fantasy%20art%20style%2C%20sparkling%20magical%20atmosphere&width=400&height=560&seq=novel-cover-10&orientation=portrait',
    description: '龙族最小的公主龙甜甜，对人类的甜点产生了浓厚的兴趣。她偷偷溜出龙族领地，伪装成人类少女来到甜品之城。在这里，她不仅要学习制作各种美味甜点，还要躲避族人的追捕，展开了一场又甜又刺激的冒险。',
    excerpt: '龙甜甜趴在甜品店的橱窗前，眼睛瞪得和铜铃一样大。人类世界的甜点也太好看了吧！草莓蛋糕、抹茶泡芙、芒果班戟...她的龙尾巴在裙子下面兴奋地摇了摇——糟糕，差点暴露了！',
    rating: 4.7,
    tags: ['奇幻', '冒险', '甜点', '萌系'],
    publishDate: '2024-05-01',
    content: '',
    wordCount: '38万字',
    status: '连载中',
  },
  {
    id: '11',
    title: '我家猫咪成精了',
    author: '小鱼干的日常',
    category: '萌系小说',
    categorySlug: 'mengxi',
    coverImage: 'https://readdy.ai/api/search-image?query=Cat%20turning%20into%20a%20cute%20boy%20illustration%2C%20girl%20surprised%20expression%2C%20soft%20cream%20and%20warm%20gray%20tones%2C%20kawaii%20anime%20style%2C%20cozy%20apartment%20setting&width=400&height=560&seq=novel-cover-11&orientation=portrait',
    description: '社恐程序媛林小晚捡了一只流浪猫回家，结果第二天早上醒来，发现猫变成了一个银发美少年！这只猫精不仅能帮她写代码、做家务，还特别粘人。从此，一人一猫的爆笑又治愈的同居生活开始了。',
    excerpt: '"主人，该起床了。早餐已经做好了，猫咪吐司配小鱼干咖啡。"银发少年穿着围裙站在床边，猫尾巴悠闲地摇晃着。林小晚把被子蒙在头上尖叫——这不是梦，她家猫真的成精了！',
    rating: 4.8,
    tags: ['萌系', '奇幻', '日常', '搞笑'],
    publishDate: '2024-03-08',
    content: '',
    wordCount: '35万字',
    status: '连载中',
  },
  {
    id: '12',
    title: '甜蜜烘焙社',
    author: '奶油泡芙',
    category: '校园小说',
    categorySlug: 'xiaoyuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Baking%20club%20illustration%20with%20students%20making%20cakes%20together%2C%20soft%20warm%20colors%2C%20kawaii%20anime%20style%2C%20school%20kitchen%20setting%20with%20sunlight%2C%20happy%20atmosphere&width=400&height=560&seq=novel-cover-12&orientation=portrait',
    description: '为了拯救濒临废社的烘焙社，社长苏甜甜想出了一个大胆的计划——参加全国高中烘焙大赛！她招募了一群奇奇怪怪的社员：从不说话的料理天才、只会做黑暗料理的富家千金、还有隔壁篮球社跑来蹭吃的少年。这场甜蜜又热血的烘焙之旅，就此展开。',
    excerpt: '"我们的社团，绝对不会解散！"苏甜甜站在桌子上，举着打蛋器大声宣布。台下的社员们面面相觑，然后不约而同地笑了。虽然只有五个人，但每个人眼里都闪着光——那是梦想和友情的光芒。',
    rating: 4.7,
    tags: ['校园', '美食', '友情', '励志'],
    publishDate: '2024-04-15',
    content: '',
    wordCount: '42万字',
    status: '连载中',
  },
];

export const heroRecommended = novels.slice(0, 4);

export const hotRanking = novels.slice(0, 8);

export const getNovelsByCategory = (slug: string): Novel[] => {
  return novels.filter((novel) => novel.categorySlug === slug);
};

export const getNovelById = (id: string): Novel | undefined => {
  return novels.find((novel) => novel.id === id);
};